import { AxiosInstance } from 'axios';

/**
 * API method to get the version of the backend
 * @param axios instance of axios
 * @returns string with backend version or empty string on error
 */
export const getBackendVersionNumber = async (axios: AxiosInstance): Promise<string> => {
  return axios
    .get('/version/')
    .then((res) => res.data)
    .catch((exc) => {
      console.error('Error while loading backend version', exc);
      return '';
    });
};
